import { defineStore } from "pinia";
import axios from "@/lib/axios";

export const useTherapistStore = defineStore("therapists", {
    state: () => ({
        therapists: [],
        selectedTherapist: null,
        loading: false,
        currentTimestamp: Math.floor(Date.now() / 1000)
    }),

    actions: {
        getTherapistFullName: function getTherapistFullName(therapist) {
            return `${therapist.first_name} ${therapist.last_name}`;
        },
        fetchTherapists: async function fetchTherapists() {
            this.loading = true;
            try {
                const response = await axios("/server/api/therapists");
                this.therapists = response.data;
                for (const key in this.therapists) {
                    this.therapists[key].full_name = this.getTherapistFullName(this.therapists[key]);
                }
            } catch (error) {
                console.error("Failed to fetch therapists:", new Error(error));
                this.therapists = [];
            } finally {
                this.loading = false;
            }
        },

        // eslint-disable-next-line func-names
        syncCalendar: async function(therapistId) {
            this.loading = true;
            try {
                await axios.post("/server/api/therapist/sync-calendar", {
                    id: therapistId
                });
            } catch (error) {
                console.error("Failed to syncCalendar therapist:", new Error(error));
            } finally {
                this.loading = false;
            }
        },

        setSelectedTherapist: function setSelectedTherapist(therapist) {
            this.selectedTherapist = therapist;
        },
    }
});
